import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AvailableLanguages, getCurrentLanguage } from "../../i18n";
import { Box, Grid, Paper, Typography, Select, MenuItem, Link } from "@material-ui/core";

import "./Footer.css";
export const footerHeight = "24px";

const Footer = () => {
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState(getCurrentLanguage());
    const date = new Date();

    const onLanguageChange = e => {
        const lng = e.target.value;
        i18n.changeLanguage(lng).then((err, t) => setLanguage(lng));
    };

    return (
        <Grid container alignItems="center" justifyContent="space-between" className="app-footer">
            <Grid item className="paper-left">
                <Typography >
                    {`Copyright © 2006-${date.getFullYear()}, `}
                    <Link href="https://www.netaphor.com/" color="inherit">{"NETAPHOR SOFTWARE INC."}</Link>
                    {` All Rights Reserved. ${date.toLocaleString()}`}
                </Typography>
            </Grid>
            <Grid item className="paper-right">
                
                    <Select id="language" value={language} onChange={onLanguageChange} >
                        {AvailableLanguages.map(v => (
                            <MenuItem key={v} value={v}>
                                {v}
                            </MenuItem>
                        ))}
                    </Select>
            </Grid>
        </Grid>
    );
};

export default Footer;
